export const getEnvVariable = (variableName: string): string => {
  const value = import.meta.env[variableName];
  if (value === undefined) {
    console.log(`Environment variable ${variableName} is not defined`);
  }
  return value;
};

export const host = getEnvVariable("VITE_HOST");
